module.exports = {
  ofertaDigital: {
    adobeTargetActive: true,
    adobeAnalyticsActive: true
  },
  ofertaReferidor: {
    adobeTargetActive: false,
    adobeAnalyticsActive: false
  },
  ofertaReferidorEmprendedores: {
    adobeTargetActive: false,
    adobeAnalyticsActive: false
  },
  ofertaReferidosEmprendedores: {
    adobeTargetActive: false,
    adobeAnalyticsActive: false
  }
};
